import {
    deleteInvoiceLoading,
    deleteInvoiceRequest,
    deleteInvoiceSuccess,
    deleteInvoiceReject,
    deleteInvoiceReset
} from "../../actions/invoice/delete";

export const deleteInvoice = (id) => async (dispatch, getState) => {
    try {
        dispatch(deleteInvoiceLoading());
        const { data } = await deleteInvoiceRequest(getState, id);
        dispatch(deleteInvoiceSuccess(data))
    } catch (error) {
        dispatch(deleteInvoiceReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteInvoiceReset()) }, 3000);
    }
    return Promise.resolve();
};